import { AdOrderItemDeclineType } from '../enum/ad-order-item-decline-type.enum';


export const adOrderItemDeclineTypeConstant: { [key in AdOrderItemDeclineType]: string } = {
  [AdOrderItemDeclineType.INAPPROPRIATE_CONTENT]: 'Неподходящий контент',
  [AdOrderItemDeclineType.COMPETITOR_AD]: 'Реклама конкурента',
  [AdOrderItemDeclineType.VIOLATES_POLICY]: 'Нарушение политики канала',
  [AdOrderItemDeclineType.LOW_BUDGET]: 'Недостаточный бюджет',
  [AdOrderItemDeclineType.SCHEDULE_CONFLICT]: 'Конфликт расписания',
  [AdOrderItemDeclineType.INCOMPLETE_INFORMATION]: 'Неполная информация',
  [AdOrderItemDeclineType.UNSUITABLE_AUDIENCE]: 'Неподходящая аудитория',
  [AdOrderItemDeclineType.TECHNICAL_ISSUES]: 'Технические проблемы',
  [AdOrderItemDeclineType.IRRELEVANT_CONTENT]: 'Нерелевантный контент',
  [AdOrderItemDeclineType.HIGH_FREQUENCY]: 'Слишком частое размещение',
  [AdOrderItemDeclineType.OTHER]: 'Другое',
};
